export default __webpack_public_path__ + "static/media/logo.e55f9538.svg";